/**
 * @ngdoc directive
 * @name cngSwitch
 * @restrict E
 *
 * @description
 * The cngSwitch directive is a checkbox with the style of a switch.
 * It can be used in the same way as an HTML checkbox
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} switchID HTML id attribute that will be on the input.
 * @param {string=} switchName HTML name attribute that will be on the input.
 * @param {string=} switchChange AngularJS expression to be executed when input changes due to user interaction with the element.
 **/
export let SwitchDirective = () => ({
  restrict: 'E',
  require: 'ngModel',
  scope: {
    switchValue: '=ngModel',
    switchChange: '&',
    switchId: '@?',
    switchName: '@?',
    switchDisabled: '<',
  },
  link: (scope, element, _, switchCtrl) => {
    scope.triggerChange = () => {
      switchCtrl.$setViewValue(scope.switchValue);
      scope.switchChange();
    };
    // fix to prevent memory leak
    scope.$on('$destroy', () => {
      // remove listener
    });
    element.on('$destroy', () => {
      scope.$destroy();
    });
  },
  template:
    '<div class="cng-switch"><input type="checkbox" id="{{switchId}}" data-ng-disabled="switchDisabled" data-ng-model="switchValue" data-ng-change="triggerChange()" name="{{switchName}}"><span role="presentation"><span></span></span></div>',
});

export default 'cngSwitch';
